import React from "react"

import "./suggestModalWrapper.scss"

const SuggestModalWrapper = ({ children }) => (
  <div className="suggest-modal__wrapper">{children}</div>
)

export default SuggestModalWrapper
